js_wine_url()
function js_wine_url(){
    document.addEventListener('DOMContentLoaded', initWineUrl)
}

// inicializar cambio de urls wine
function initWineUrl() {
    const url_16s = document.querySelectorAll('.js-wine-url__16')
    const url_40s = document.querySelectorAll('.js-wine-url__40')
    const url_56s = document.querySelectorAll('.js-wine-url__56')
    
    if (url_16s != null) {
        changeUrl16(url_16s)
    }

    if (url_40s != null) {
        changeUrl40(url_40s)
    }

    if (url_56s != null) {
        changeUrl56(url_56s)
    }

    function changeUrl16(urls){
        urls.forEach(url => {
            url.href = `${localStorage.wine_url}/?view=w1`
        })
    }

    function changeUrl40(urls){
        urls.forEach(url => {
            url.href = `${localStorage.wine_url}/?view=w4`
        })
    }

    function changeUrl56(urls){
        urls.forEach(url => {
            url.href = `${localStorage.wine_url}`
        })
    }
}
